import { useCallback } from "react";
import { SlideNavigationWrapperItemCustomLink } from "shared/pages/explore/styles";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useRouteMatch } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LinkTo } from "shared/constants/linkTo";

const TeamEmployeesLink = ({ team }: any) => {
    const history = useHistory();
    const isMain = !!useRouteMatch(['/'])?.isExact;
    const { t } = useTranslation();

    const { contextName, teamId, moderationType, contexts } = team;

    const isLMSCourse = contexts && contexts.length > 0 && moderationType === ModerationType.LMS;

    const onTeamClick = useCallback(() => {
        if (!isMain) {
            history.push(`/teams/${contextName || teamId}/employees`)
            return;
        }
        history.push(LinkTo.Employees)
    }, [contextName, teamId, isMain])

    return (
        <SlideNavigationWrapperItemCustomLink isTeamLink onClick={onTeamClick}
            white_theme={false}
            active={false} isLMSCourse={isLMSCourse}>
            <svg data-for={'tooltip-parent-element'} className={'team-link-svg'} data-tip={t('nav.team')} width="28" height="28"
                viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="27" height="27" rx="2.5" stroke="#B6B6B5" />
                <path
                    d="M16.6579 19.8123V11.6305H19.2627V19.8123H16.6579ZM17.963 10.677C17.5972 10.677 17.2829 10.5563 17.0202 10.3148C16.7574 10.0698 16.626 9.77504 16.626 9.43058C16.626 9.08967 16.7574 8.79847 17.0202 8.557C17.2829 8.31197 17.5972 8.18945 17.963 8.18945C18.3323 8.18945 18.6466 8.31197 18.9058 8.557C19.1686 8.79847 19.3 9.08967 19.3 9.43058C19.3 9.77504 19.1686 10.0698 18.9058 10.3148C18.6466 10.5563 18.3323 10.677 17.963 10.677Z"
                    fill="#909090" />
                <path
                    d="M12.695 19.8123V11.6305H15.2998V19.8123H12.695ZM14.0001 10.677C13.6343 10.677 13.32 10.5563 13.0573 10.3148C12.7945 10.0698 12.6631 9.77504 12.6631 9.43058C12.6631 9.08967 12.7945 8.79847 13.0573 8.557C13.32 8.31197 13.6343 8.18945 14.0001 8.18945C14.3694 8.18945 14.6837 8.31197 14.9429 8.557C15.2057 8.79847 15.3371 9.08967 15.3371 9.43058C15.3371 9.77504 15.2057 10.0698 14.9429 10.3148C14.6837 10.5563 14.3694 10.677 14.0001 10.677Z"
                    fill="#909090" />
                <path
                    d="M8.73216 19.8123V11.6305H11.3369V19.8123H8.73216ZM10.0372 10.677C9.67143 10.677 9.35716 10.5563 9.09437 10.3148C8.83159 10.0698 8.7002 9.77504 8.7002 9.43058C8.7002 9.08967 8.83159 8.79847 9.09437 8.557C9.35716 8.31197 9.67143 8.18945 10.0372 8.18945C10.4065 8.18945 10.7208 8.31197 10.98 8.557C11.2428 8.79847 11.3742 9.08967 11.3742 9.43058C11.3742 9.77504 11.2428 10.0698 10.98 10.3148C10.7208 10.5563 10.4065 10.677 10.0372 10.677Z"
                    fill="#909090" />
            </svg>
        </SlideNavigationWrapperItemCustomLink>
    )
}

export default TeamEmployeesLink;import { useCallback } from "react";
import { SlideNavigationWrapperItemCustomLink } from "shared/pages/explore/styles";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useRouteMatch } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LinkTo } from "shared/constants/linkTo";

const TeamEmployeesLink = ({ team }: any) => {
    const history = useHistory();
    const isMain = !!useRouteMatch(['/'])?.isExact;
    const { t } = useTranslation();

    const { contextName, teamId, moderationType, contexts } = team;

    const isLMSCourse = contexts && contexts.length > 0 && moderationType === ModerationType.LMS;

    const onTeamClick = useCallback(() => {
        if (!isMain) {
            history.push(`/teams/${contextName || teamId}/employees`)
            return;
        }
        history.push(LinkTo.Employees)
    }, [contextName, teamId, isMain])

    return (
        <SlideNavigationWrapperItemCustomLink isTeamLink onClick={onTeamClick}
            white_theme={false}
            active={false} isLMSCourse={isLMSCourse}>
            <svg data-for={'tooltip-parent-element'} className={'team-link-svg'} data-tip={t('nav.team')} width="28" height="28"
                viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="27" height="27" rx="2.5" stroke="#B6B6B5" />
                <path
                    d="M16.6579 19.8123V11.6305H19.2627V19.8123H16.6579ZM17.963 10.677C17.5972 10.677 17.2829 10.5563 17.0202 10.3148C16.7574 10.0698 16.626 9.77504 16.626 9.43058C16.626 9.08967 16.7574 8.79847 17.0202 8.557C17.2829 8.31197 17.5972 8.18945 17.963 8.18945C18.3323 8.18945 18.6466 8.31197 18.9058 8.557C19.1686 8.79847 19.3 9.08967 19.3 9.43058C19.3 9.77504 19.1686 10.0698 18.9058 10.3148C18.6466 10.5563 18.3323 10.677 17.963 10.677Z"
                    fill="#909090" />
                <path
                    d="M12.695 19.8123V11.6305H15.2998V19.8123H12.695ZM14.0001 10.677C13.6343 10.677 13.32 10.5563 13.0573 10.3148C12.7945 10.0698 12.6631 9.77504 12.6631 9.43058C12.6631 9.08967 12.7945 8.79847 13.0573 8.557C13.32 8.31197 13.6343 8.18945 14.0001 8.18945C14.3694 8.18945 14.6837 8.31197 14.9429 8.557C15.2057 8.79847 15.3371 9.08967 15.3371 9.43058C15.3371 9.77504 15.2057 10.0698 14.9429 10.3148C14.6837 10.5563 14.3694 10.677 14.0001 10.677Z"
                    fill="#909090" />
                <path
                    d="M8.73216 19.8123V11.6305H11.3369V19.8123H8.73216ZM10.0372 10.677C9.67143 10.677 9.35716 10.5563 9.09437 10.3148C8.83159 10.0698 8.7002 9.77504 8.7002 9.43058C8.7002 9.08967 8.83159 8.79847 9.09437 8.557C9.35716 8.31197 9.67143 8.18945 10.0372 8.18945C10.4065 8.18945 10.7208 8.31197 10.98 8.557C11.2428 8.79847 11.3742 9.08967 11.3742 9.43058C11.3742 9.77504 11.2428 10.0698 10.98 10.3148C10.7208 10.5563 10.4065 10.677 10.0372 10.677Z"
                    fill="#909090" />
            </svg>
        </SlideNavigationWrapperItemCustomLink>
    )
}

export default TeamEmployeesLink;